import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useAnnotationDelete = () => {
  const createPostRequest = (id) => {
    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/annotation/${id}/`;
    return new Request(requestUrl, {
      method: "DELETE",
      body: JSON.stringify({}),
      headers: { "Content-Type": "application/json" },
    });
  };

  return useRestMutation(createPostRequest);
};
export default useAnnotationDelete;
